import React from "react";
import { useSelector } from "react-redux";
import styles from "./Comment.module.css";
import { translate, translateElapsed } from "../../../../../../common/providers";
import { CustomIconButton, icon, UserAvatar } from "../../../../../../common/components";

export default function Comment({ owner = false, comment = null, onEdit }) {
	const companyId = useSelector(({ context }) => context.company?.id);
	const projectId = useSelector(({ context }) => context.project?.id);

	return (
		<div className={styles.comment} data-testid="add.comment.div">
			{comment && (
				<>
					<div className={styles.comment__header}>
						<UserAvatar
							companyId={companyId}
							displayName={comment?.userName}
							projectId={projectId}
							size="xs"
							userId={comment?.userId}
						/>
						<div className={styles.comment__info}>
							<span className={styles.comment__userName}>{comment?.userName}</span>
							<span className={styles.comment__elapsed}>
								{translateElapsed({
									value: comment.elapsed.value,
									unitKey: comment.elapsed.unit,
								})}
							</span>
						</div>
						{owner && (
							<CustomIconButton
								icon={icon.faPenToSquare}
								role="presentation"
								size="sm"
								tooltip={translate("common:btn.edit")}
								variant="outlined"
								onClick={onEdit}
							/>
						)}
					</div>
					<div className={styles.comment__content}>{comment?.content}</div>
				</>
			)}
		</div>
	);
}
